import { useState } from "react";
import { useForm } from "react-hook-form";
import Head from "next/head";
import { useToast } from "~/utils";
import { FormSubmitButton } from "~/components/FormSubmitButton";
import { Main } from "~/components/aud/base/Main";
import { Section } from "~/components/aud/base/Section";
import { Content } from "~/components/aud/base/Content";
import { PageTitle } from "~/components/aud/ui/PageTitle";
import { useSendResetPasswordLinkMutation } from "~/hooks/rtk-query-api";
import { EmailField } from "~/components/settings/EmailField";

const PasswordResetPage = () => {
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [sendResetPasswordLink] = useSendResetPasswordLinkMutation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = async (data) => {
    setLoading(true);
    try {
      await sendResetPasswordLink({
        sendResetPasswordLinkInput: { email: data.email },
      }).unwrap();
      toast.success("入力いただいたメールアドレスに確認メールを送信しました。");
    } catch (e) {
      toast.error(e.data?.error ?? "エラーが発生しました。お手数ですがもう一度時間を開けておためしください。");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Main>
      <Head>
        <title>Forgot Password?</title>
      </Head>
      <Section>
        <PageTitle title="Forgot Password?" sub="パスワードの再設定" />
        <p>
          パスワードをお忘れの方は登録しているメールアドレスを入力し、確認メールを受け取ることでパスワードを再登録できます。
        </p>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Content>
            <div className="_form">
              <EmailField register={register} errors={errors} />
              <div className="field">
                <FormSubmitButton loading={loading} size="medium">
                  確認メールを送信
                </FormSubmitButton>
              </div>
            </div>
          </Content>
        </form>
      </Section>
    </Main>
  );
};

export default PasswordResetPage;
